import React, { useState } from "react";
import { shallowEqual, useSelector } from "react-redux";

export function MoneyFormatterCustom(money, currency) {
  return (
    currency.symbol +
    money.toLocaleString(undefined, { minimumFractionDigits: 2 })
  );
}

export const MoneyFormatter = (cellContent, row, rowIndex) => (
  <>
    {cellContent != undefined && (
      <span>
        {row.currency.symbol}
        {cellContent.toLocaleString(undefined, { minimumFractionDigits: 2 })}
      </span>
    )}
    <> </>
  </>
);
export const DateFormatter = (cellContent, row, rowIndex) => (
  <>
    {cellContent != undefined && (
      <span>{new Date(cellContent).toLocaleDateString()}</span>
    )}
    <> </>
  </>
);
export const DateTimeFormatter = (cellContent, row, rowIndex) => (
  <>
    {cellContent != undefined && (
      <span>{new Date(cellContent).toLocaleString()}</span>
    )}
    <> </>
  </>
);
